import React from "react";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

export const NEEDS_PRICE_COLOR = "#dfad1d";

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const useStyles = makeStyles((theme) => ({
  summary: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2, 3),
  },
  summaryLabel: {
    color: theme.palette.text.secondary,
    fontSize: "0.7rem",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
  },
  summaryValue: {
    fontWeight: 600,
    fontSize: "1.1rem",
  },
}));

// Running totals for a list of nightly rates. Nights flagged needsPrice are
// left out. Add-ons, resort fee and coupon discount are not included.
const RatesSummary = ({ ratesData, roomQty = 1, note }) => {
  const classes = useStyles();
  const pricedRates = ratesData.filter((rate) => !rate.needsPrice);
  const unpricedNights = ratesData.length - pricedRates.length;
  const subtotalCents = Math.round(
    pricedRates.reduce((acc, rate) => acc + (Number(rate.price) || 0), 0) *
      roomQty *
      100
  );
  const taxCents = Math.round(
    pricedRates.reduce(
      (acc, rate) =>
        acc + (Number(rate.price) || 0) * ((Number(rate.tax) || 0) / 100),
      0
    ) *
      roomQty *
      100
  );

  if (ratesData.length === 0) return null;

  const item = (label, value) => (
    <Grid item xs={6} sm={3}>
      <Typography className={classes.summaryLabel}>{label}</Typography>
      <Typography className={classes.summaryValue}>{value}</Typography>
    </Grid>
  );

  return (
    <Paper className={classes.summary} variant="outlined">
      <Grid container spacing={2}>
        {item(
          "Nights",
          `${ratesData.length}${roomQty > 1 ? ` × ${roomQty} rooms` : ""}`
        )}
        {item("Rates Subtotal", currencyFormat.format(subtotalCents / 100))}
        {item("Rates Tax", currencyFormat.format(taxCents / 100))}
        {item(
          "Rates Total",
          currencyFormat.format((subtotalCents + taxCents) / 100)
        )}
      </Grid>
      {(unpricedNights > 0 || note) && (
        <Typography variant="caption" color="textSecondary" display="block">
          {unpricedNights > 0 && (
            <span style={{ color: NEEDS_PRICE_COLOR }}>
              {unpricedNights} night{unpricedNights === 1 ? " is" : "s are"} not
              priced yet and not included.{" "}
            </span>
          )}
          {note}
        </Typography>
      )}
    </Paper>
  );
};

export default RatesSummary;
